import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga';
import Config from 'utils/getEnvConfig';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {
  makeSelectClientDetails,
  makeSelectClientDetailsFetching,
} from 'containers/Main/selectors';
import { isBot } from 'utils/stringUtils';
import { isLocalhost } from 'utils/networkUtils';

const usePageTracking = () => {
  const clientDetails = useSelector(makeSelectClientDetails());
  const clientDetailsFetching = useSelector(makeSelectClientDetailsFetching());
  const GTMID = _get(clientDetails, 'context.GTMID', false);
  const shortName = _get(clientDetails, 'shortName', '');
  const isClient = !_isEmpty(clientDetails);
  const enableTrack = !isBot() && !isLocalhost;
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (enableTrack) {
      // init GA
      ReactGA.initialize(Config.GA);
      ReactGA.pageview(pathname + search);
    }
  }, []);

  useEffect(() => {
    if (GTMID && enableTrack) {
      // init client own gtm
      TagManager.initialize({
        gtmId: GTMID,
      });
    }
    if (shortName && enableTrack) {
      // init all clients gtm
      TagManager.initialize({
        gtmId: Config.CLIENTS_GTM_ID,
      });
    }
    const initTimer = setTimeout(() => {
      if (
        !shortName &&
        !clientDetailsFetching &&
        !GTMID &&
        !isClient &&
        enableTrack
      ) {
        // gtm for public/not branded sites
        TagManager.initialize({
          gtmId: Config.GTM_ID,
        });
      }
    }, 1000);
    return () => clearTimeout(initTimer);
  }, [GTMID, shortName]);
};

export default usePageTracking;
